import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { withCoreComponent } from 'core/hocs';
import { FormattedTag, ChangeRoute, CategoryGames as CategoryGamesCore } from 'core/components';
import { isEmptyOrNil } from 'core/helpers';
import { GAMES_CATEGORY_PAGE } from 'core/constants';

import { Main } from 'components/main/main';
import { GameCard } from 'components/game-card/game-card';
import { GamesGridPreloader } from 'components/games-grid-preloader/games-grid-preloader';

import './category-games.scss';

const GAMES_CATEGORY_ID = {
  [GAMES_CATEGORY_PAGE.RECENTLY_PLAYED]: 'games.recently-played',
  [GAMES_CATEGORY_PAGE.RECOMMENDED]: 'games.recommended',
  [GAMES_CATEGORY_PAGE.CHRISTMAS]: 'games.christmas',
  [GAMES_CATEGORY_PAGE.NEWEST]: 'games.newest',
  [GAMES_CATEGORY_PAGE.JACKPOTS]: 'games.jackpots',
  [GAMES_CATEGORY_PAGE.TOP_GAMES]: 'games.most-popular',
};

export const CategoryGamesUI = ({
  games,
  showMore,
  isShowMoreAvailable,
  isUserLoggedIn,
  toggleFavoriteGame,
  isInProgress,
  openGame,
  category,
}) => {
  if (!isUserLoggedIn && category === GAMES_CATEGORY_PAGE.RECENTLY_PLAYED) {
    return <ChangeRoute to="/" />;
  }

  return (
    <Main>
      <FormattedTag id={GAMES_CATEGORY_ID[category]} tag="div" className="h2 mt-5 mt-md-8_5 mb-sm-5 mb-md-6 text-center letter-spacing-extra games-category-title" />

      {isInProgress
        ? <GamesGridPreloader rows={3} />
        : isEmptyOrNil(games)
        && <FormattedTag tag="div" className="text-center" id="games.no-games" />
        || (
          <div className="games-category-list">
            {games.map((game, idx) => (
              <GameCard
                // eslint-disable-next-line react/no-array-index-key
                key={`${game.gameId}-${game.producer}-${idx}`}
                {...game}
                isUserLoggedIn={isUserLoggedIn}
                toggleFavoriteGame={toggleFavoriteGame}
                openGame={openGame}
                withJackpotAmount
              />
            ))}
          </div>
        )}
      {isShowMoreAvailable && (
        <FormattedTag
          id="show-more"
          color="gray-10"
          tag={Button}
          className="games-category-show-more d-block mx-auto mt-2_25 btn-outline-gray-5 w-100"
          onClick={showMore}
          outline
        />
      )}
    </Main>
  );
};

CategoryGamesUI.propTypes = {
  isUserLoggedIn: PropTypes.bool.isRequired,
  games: PropTypes.arrayOf(PropTypes.shape()),
  isShowMoreAvailable: PropTypes.bool.isRequired,
  showMore: PropTypes.func.isRequired,
  openGame: PropTypes.func.isRequired,
  toggleFavoriteGame: PropTypes.func.isRequired,
  category: PropTypes.string.isRequired,
  isInProgress: PropTypes.bool.isRequired,
};

CategoryGamesUI.defaultProps = {
  games: [],
};

export const CategoryGames = withCoreComponent(CategoryGamesCore, CategoryGamesUI);
